export default "__VITE_ASSET__BlO7vX8S__"